import { environment } from 'src/environments/local/environment';

export const formatPhoneNumber = (
  domain: 'nl' | 'se',
  phone: string
): string => {
  const code = domain === 'nl' ? '31' : '46';

  if (!phone) {
    return phone;
  }

  if (phone.substring(0, 3) === `+${code}`) {
    return `00${code}${phone.substring(3, phone.length)}`;
  }

  if (phone.substring(0, 4) !== `00${code}`) {
    return `00${code}${phone.substring(1, phone.length)}`;
  }

  return phone;
};

export const mapPhoneNumber = (phoneNumber: string): string => {
  if (
    phoneNumber.startsWith('0046') ||
    phoneNumber.startsWith('00358') ||
    phoneNumber.startsWith('0031')
  ) {
    return phoneNumber;
  } else if (
    phoneNumber.startsWith('46') ||
    phoneNumber.startsWith('358') ||
    phoneNumber.startsWith('31')
  ) {
    return `00${phoneNumber}`;
  } else {
    return `${environment.countryPrefix}${
      phoneNumber.startsWith('0') ? phoneNumber.slice(1) : phoneNumber
    }`;
  }
};

export const formatPhoneNumberBackToClient = (phoneNumber: string): string => {
  if (
    phoneNumber.startsWith('0046') ||
    phoneNumber.startsWith('00358') ||
    phoneNumber.startsWith('0031')
  ) {
    return `0${phoneNumber.slice(environment.countryPrefix.length)}`;
  }
  return phoneNumber;
};
